import { MatterLawWorksChargesSection } from "@/components/features/lawworks-charges/LawWorksChargesPage";
import { Text } from "@/components/ui";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/matters/$matterId/_layout/charges",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { matterId } = Route.useParams();
  return (
    <div className="flex flex-col gap-6 p-6">
      <Text variant="title">Charges</Text>
      <MatterLawWorksChargesSection matterId={matterId} />
    </div>
  );
}
